"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var flApi_1 = require("./lib/flApi");
exports.default = {
    api: flApi_1.Api.getInstance(),
    app: flApi_1.ApplicationEntity,
    usr: flApi_1.UserClass,
    version: function () { return require('../../../package.json').version; }
};
